import { render, staticRenderFns } from "./TopicManageList.vue?vue&type=template&id=1d40189f&scoped=true&"
import script from "./TopicManageList.vue?vue&type=script&lang=js&"
export * from "./TopicManageList.vue?vue&type=script&lang=js&"
import style0 from "./TopicManageList.vue?vue&type=style&index=0&id=1d40189f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d40189f",
  null
  
)

export default component.exports